import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "language-switcher" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dropdown, {
      options: _ctx.languageOptions,
      optionLabel: "label",
      optionValue: "code",
      modelValue: _ctx.selectedLanguage,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
      onChange: _ctx.changeLanguage,
      placeholder: "Select Language",
      class: "p-dropdown"
    }, null, 8, ["options", "modelValue", "onChange"])
  ]))
}